<template>
    <sub-menu id="home" class="navigation-home">
        <sub-menu-item :to="'/digital-signage|/affichage-numerique'|tr" icon="fa-tv">
            <span v-tr>Digital Signage|Affichage numérique</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/menuboards|/affichage-numerique/menus-restaurants" icon="fa-utensils">
            <span v-tr>Digital Menu Boards|Menus numérique</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/healthcare|/affichage-numerique/sante-et-hopitaux" icon="fa-hospital">
            <span v-tr>Signage for Healthcare|Affichage pour la santé</span>
        </sub-menu-item>
        <sub-menu-divider/>
        <sub-menu-item to="/digital-signage/interactive-touch-kiosk|/affichage-numerique/kiosk-tactile-interactif" icon="fa-rectangle-vertical-history">
            <span v-tr>Wayfinding Kiosk|Kiosque tactile de navigation</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/videowalls|/affichage-numerique/mur-ecrans-video" icon="fa-gallery-thumbnails">
            <span v-tr>Video Wall|Murs vidéo</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/holograms|/affichage-numerique/hologrammes" icon="fa-atom">
            <span v-tr>3D Holograms|Hologrammes 3D</span>
        </sub-menu-item>
        <sub-menu-divider/>
        <sub-menu-item to="/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social" icon="fa-wifi">
            <span v-tr>Guest & Social WiFi|WiFi public & social</span>
        </sub-menu-item>
        <sub-menu-item to="/wifi/retail-shopping-mall|/wifi-public/commerces-et-centres-commerciaux" icon="fa-shopping-bag">
            <span v-tr>WiFi CRM for Malls & Retail|CRM WiFi pour Détaillants</span>
        </sub-menu-item>
        <sub-menu-item to="/wifi-on-board/coaches-and-bus|/wifi-a-bord/bus-et-navettes" icon="fa-bus">
            <span v-tr>Transports & Bus WiFi|WiFi pour bus & transports</span>
        </sub-menu-item>
<!--        <sub-menu-divider/>-->
<!--        <sub-menu-item :to="'/mobile-apps/universal-applications|/applications-mobiles/app-universelles'|tr" icon="fa-mobile-alt">-->
<!--            <span v-tr>Mobile Apps</span>-->
<!--        </sub-menu-item>-->
    </sub-menu>
</template>

<script>

import SubMenuItem from "@/components/sub-menu-item.vue";
import SubMenu from "@/components/sub-menu.vue";
import SubMenuDivider from "../components/sub-menu-divider.vue";
export default {
    name: `home-navigation`,
    components: {SubMenuDivider, SubMenuItem, SubMenu}
}
</script>

<style lang="scss" scoped>
.navigation-home {
    // for sticky position
    top: -100px;
}
</style>
